import { render, staticRenderFns } from "./SurveyQuestionChart.vue?vue&type=template&id=dc074dc4&scoped=true&"
import script from "./SurveyQuestionChart.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc074dc4",
  null
  
)

export default component.exports